import {toCamelCaseProperties} from '@/utils/fn';
import WebshopProductDetail from "@/services/models/webshop/WebshopProductDetail";

export default class WebshopProduct {
   constructor(args) {
      args = toCamelCaseProperties(args) || {};
      this.productDetails = new WebshopProductDetail(args);
      this.odinProductId = args.odinProductId || -1;
      this.id = args.id;
      this.quantity = args.quantity || 0;
      this.idBase64 = args.idBase64?.Base64Guid || args.base64Id;
      this.siteIds = args.siteIds || [];
      this.title = args.name;
      this.urlSafeTitle = args.urlSafeName;
      this.description = args.description;
      this.visible = args.visible;
      this.categoryId = args.categoryId || -1;
      this.imgUrl = args.imageUrl || 'http://res.cloudinary.com/odin-systemer/image/upload/h_550,w_550,c_lpad,b_white,d_defaults:d_product.png/v1459843120/supplierProduct/3861.jpg'
      this.videoUrl = args.videoUrl;
      this.brandName = args.brandName;
      this.brandId = args.brandId;
      this.serieName = args.seriesName;
      this.seriesId = args.seriesId;
      this.salePrice = args.discounts?.length ? args.discounts[0].DiscountPrice : 0;
      this.brandImgUrl = '//res.cloudinary.com/odin-systemer/image/upload/h_229,w_430,c_lpad,b_white,d_defaults:d_brand.png/v1459938004/supplierBrand/47.jpg';
      this.campaignPrice = args.campaignPrice || 0;
      this.campaignDiscount = 0;
      this.discounts = args.discounts;
      this.isAdditionalProduct = args.isAdditionalProduct || false
      this.bestCampaign = args.bestCampaign || null
      // this.salesPrice = args.salesPrice || 0;
   }
}
